import React, { ReactNode } from "react";

// Define prop types for WrapperContent
interface WrapperContentProps {
  children: ReactNode;
}

const WrapperContent: React.FC<WrapperContentProps> = ({ children }) => {
  return <div className="m-content">{children}</div>;
};

export default WrapperContent;
